export default __webpack_public_path__ + "media/titles/title_3_locale_de-e797fcd7.png";